export const API_ENDPOINTS = {
  USERS: {
    LOGIN: "users/login/",
    LOGOUT: "users/logout/",
    GET_ALL: "users/", // Used for fetching CSOs with query params
    ME: "users/me/",
    UPDATE: (id: number | string) => `users/${id}/`,
  },
  CUSTOM_FORMS: {
    LIST: "custom_forms/",
    DETAILS: (id: number | string) => `custom_forms/${id}/`,
    CATEGORIES: "custom_forms/assessment-categories/",
    SUBCATEGORIES: (id: number | string) =>
      `custom_forms/assessment-subcategories/?category_id=${id}`,
  },
  ASSESSMENTS: {
    SUBMIT: "assessments/submit/",
    PREFILL_VALUES: "assessments/get-values-for-form/",
    CONDUCTED_BY: (id?: string | number) =>
      id
        ? `assessments/conducted-by/?mall_id=${id}`
        : `assessments/conducted-by/`,
    SUBMIT_DRAFT: "assessments/submit-as-draft/",
    SHARE_SECTION: (id: string | number) => `assessments/${id}/share-section/`,
    MY_SHARED_SECTIONS: "assessments/my-shared-sections/",
    SHARED_SECTIONS_TO: (id: string | number) =>
      `assessments/shared-sections-to/${id}/`,
    ASSESSMENT_DETAILS: "assessments/{id}/",
    ASSESSMENT_DETAIL: (id: string | number) => `assessments/${id}/`,
    FINAL_SUBMIT: (id: string | number) => `assessments/final-submit/${id}/`,
    UPDATE: (id: string | number) => `assessments/update/${id}/`,
    NON_COMPLIANCE: (id: string | number) =>
      `assessments/is-not-compliant/${id}/`,
    GET_NOT_COMPLIANT: "assessments/not-compliant-assessments/",
    RESOLVE_NOT_COMPLIANT: (id: string | number) =>
      `assessments/resolve-not-compliant/${id}/`,
  },
  ASSESSMENT_HISTORY: "dashboards/assessment-history/{id}/",
  CREATE_SESSION: "/sockets/session/create/",
  CREATE_GROUP_SESSION: "/sockets/group/session/create/",
  GET_GROUP_LIST: "/sockets/group/session/get/",
  GET_CHAT_LIST: "/sockets/session/get/",
  GET_CHAT_HISTORY: "/sockets/chat/get/",
  GET_GROUP_CHAT_HISTORY: "/sockets/group/chat/get/",
  CHAT_INSIGHTS: "/sockets/infobip/chat-insights/",
  CHAT_INSIGHTS_DETAIL: (id: string | number) =>
    `/sockets/infobip/chat-insights/${id}/`,
  CHAT_AGENTS: "/sockets/infobip/chat/agents/",
  CREATE_COACHING_SESSION: "/malls/create-coaching-session/",
  MEDIA: "media/create/",
  ADD_SCORE: "/malls/nps-mystery-shopper/",
  GET_SCORE: (mall_id: string | number, assessment_type: string) =>
    `/malls/nps-mystery-shopper/${mall_id}/?assessment_type=${assessment_type}`,
  MALLS: {
    LIST: "malls/",
    DIGITAL_ASSETS: "/malls/mall-discrepancy/results/",
    COACHING_LIST: "malls/coaching/",
  },
  DASHBOARDS: {
    CONDUCTED_BY_BREAKDOWN: "dashboards/conducted-by-assessment-breakup/",
    CSO_BREAKDOWN: "dashboards/cso-assessment-by-breakdown/",
    EVALUATOR_BREAKDOWN: "dashboards/evaluator-breakdown-overview/",
    TOP_PERFORMING_CSO: (id?: string | number) =>
      `dashboards/top-performing-cso/${id ? `?mall_id=${id}` : ""}`,
    OPP_ASSESSMENT_HISTORY: (id: string | number) =>
      `dashboards/opp-assessment-history/${id}/`,
    NPS_GRAPH: "dashboards/nps-graph/",
    MYSTERY_SHOPPER_GRAPH: "dashboards/mystery-shopper-graph/",
    EVALUATOR_SUPERVISOR: (mall_id: string | number) =>
      `dashboards/evaluator-supervisor-dashboard/?mall_id=${mall_id}`,
    BI_WEEKLY_AI_INSIGHTS: (mall_id: string | number) =>
      `dashboards/bi-weekly-ai-insights/?mall_id=${mall_id}`,
    CSO_DASHBOARD: (cso_id: string | number) =>
      `dashboards/cso-dashboard/?cso_id=${cso_id}`,
  },
  TARGETS: {
    CREATE: "targets/create/",
    GET_LIST: (mall_id: string | number) => `targets/?mall_id=${mall_id}`,
  },
  NOTIFICATIONS: {
    LIST: "notifications/",
  },
};
